const checkAyvensVehicle = async (licencePlate, serviceId) => {
  var axios = require("axios");
  const url =
    process.env.REACT_APP_BACKEND_API_URL +
    "/integrations/ayvens/get-vehicle-and-conditions?licencePlate=" +
    licencePlate +
    "&serviceId=" +
    serviceId +
    "&apikey=" +
    process.env.REACT_APP_TOKEN_API;

  var config = {
    method: "get",
    url: url,
    headers: {
      "Content-Type": "application/json",
    },
    timeout: 60000,
    maxContentLength: Infinity,
    maxBodyLength: Infinity,
    // data: data,
  };

  return await axios
    .request(config)
    .then((response) => {
      return response?.data?.data;
    })
    .catch((error) => {
      return error.response.data;
    });
};

const createAyvensOrder = async (serviceId) => {
  var axios = require("axios");
  var config = {
    method: "post",
    url: process.env.REACT_APP_BACKEND_API_URL + "/integrations/ayvens/create-order?apikey=" + process.env.REACT_APP_TOKEN_API + "&serviceId=" + serviceId,
    headers: {
      "Content-Type": "application/json",
    },
  };
  return await axios(config)
    .then((response) => {
      return response?.data?.data;
    })
    .catch((error) => {
      return error.response.data;
    });
};

const approveAyvensOrder = async (serviceId) => {
  var axios = require("axios");
  const url =
    process.env.REACT_APP_BACKEND_API_URL +
    "/integrations/ayvens/approve-order?serviceId=" +
    serviceId +
    "&" +
    "&apikey=" +
    process.env.REACT_APP_TOKEN_API;
  var config = {
    method: "post",
    url: url,
    headers: {
      "Content-Type": "application/json",
    },
  };
  return await axios(config)
    .then((response) => {
      return response?.data;
    })
    .catch((error) => {
      return error.response.data;
    });
};

export { checkAyvensVehicle, createAyvensOrder, approveAyvensOrder };
